import { track } from './amplitude';
import {
  FIRST_VISIT,
  TIME_TO_FIRST_INTERACTION,
  SESSION_EXIT,
} from './events';
import { userInteracted, $appState } from '../state/appState';

const VISITED_STORAGE_KEY = 'pilgrim_visited';

const trackFirstVisit = () => {
  try {
    if (!localStorage.getItem(VISITED_STORAGE_KEY)) {
      track(FIRST_VISIT);
      localStorage.setItem(VISITED_STORAGE_KEY, '1');
    }
  } catch {
    // localStorage unavailable (private browsing, etc.)
  }
};

const trackTimeToFirstInteraction = () => {
  const startTime = performance.now();
  let tracked = false;

  const unwatch = userInteracted.watch(() => {
    if (tracked) return;
    tracked = true;

    const durationMs = Math.round(performance.now() - startTime);
    track(TIME_TO_FIRST_INTERACTION, {
      duration_ms: durationMs,
      duration_sec: +(durationMs / 1000).toFixed(2),
    });

    unwatch();
  });
};

const trackSessionExit = () => {
  // `pagehide` надёжнее `beforeunload` на мобильных Safari/Chrome —
  // последний часто не вызывается при swipe-close вкладки или system
  // kill. `pagehide` стреляет всегда (включая случай ухода в bfcache,
  // `event.persisted: true`); Amplitude SDK сам ставит sendBeacon
  // в этом обработчике, так что событие доходит до закрытия страницы.
  let dispatched = false;
  const handler = () => {
    if (dispatched) return;
    dispatched = true;
    const state = $appState.getState();
    const currentState = state.state;

    track(SESSION_EXIT, {
      last_scene: state.sceneId,
      last_state: currentState.type,
      last_sight:
        currentState.type === 'sight-details' ? currentState.sightId : null,
    });
  };
  window.addEventListener('pagehide', handler);
};

export const startSessionTracking = () => {
  trackFirstVisit();
  trackTimeToFirstInteraction();
  trackSessionExit();
};
